import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getSecurityId } from '../../reducers/users';
import get from 'lodash/get';
import API from '../../services/api';
import { setLoading, showSnackbar, toggleModal } from '../../reducers/ui';
import { errorHandler } from '../../utils/errorMessages';
import { actions as businessClientActions } from 'containers/Pages/People/BusinessClients/Modules/dataGridTable';
import { actions as businessClientFilterActions } from 'containers/Pages/People/BusinessClients/Modules/filters';
import { nameSpace } from '../../containers/Pages/People/BusinessClients/Modules/nameSpace';
import { actions as embeddedFormActions } from 'modules/embeddedForms/reducer';

export function* fetchBizClientRequest({ filters, from }) {
  try {
    const securityCompanyId = yield select(getSecurityId);

    const options = {
      securityCompanyId,
      archived: get(filters, 'archived', false),
      search: get(filters, 'search'),
      departmentId: get(filters, 'departmentId'),
      from,
    };
    const { data } = yield call(API.fetchBusinessClientList, options);

    if (data.data !== null) {
      const totalEntries = get(data, 'meta.total');
      return { list: data.data, totalEntries };
    }
    return false;
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
    return false;
  }
}

function* fetchBusinessClientsSaga({ payload }) {
  const { filters, from } = payload;
  try {
    yield put(setLoading(true));
    const data = yield call(fetchBizClientRequest, { filters, from });
    // const globalBiz = yield select(getBusinessClientList);
    if (data) {
      const { list, totalEntries } = data;
      //get the actions from the module to assign the stuff.
      yield put(
        businessClientActions.setGridList({
          list,
          totalEntries: totalEntries,
        }),
      );
      yield put(businessClientFilterActions.setFilterKey(false));
      yield put(businessClientActions.setForceRefresh(false));
      yield put(setLoading(false));
    }
  } catch (err) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}

export function* fetchBusinessClientDetailsSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id } = payload;
    const { data } = yield call(API.fetchBusinessClientDetail, id);
    if (data.data) {
      yield put(
        businessClientActions.setGridRowDetails({ details: data.data }),
      );
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}

export function* createBusinessClientSaga({ payload }) {
  const { businessClient, embeddedForm } = payload;
  try {
    yield put(setLoading(true));
    const { data, status } = yield call(API.addBusinessClient, businessClient);
    if (status === 200 && embeddedForm) {
      yield put(
        embeddedFormActions.setEmbeddedFormDetails({
          formType: nameSpace,
          details: data.data,
        }),
      );
      // pass this info into the embedded form state
    }
    // only flip the modal if the form is opened in the actual business client component
    if (!embeddedForm) {
      yield put(toggleModal(nameSpace));
    }

    yield put(setLoading(false));
  } catch (err) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}
export function* updateBusinessClientSaga({ payload }) {
  const { id, businessClient } = payload;
  try {
    yield put(setLoading(true));
    const { status } = yield call(API.updateBusinessClient, id, businessClient);
    if (status === 200) {
      yield call(fetchBusinessClientDetailsSaga, { payload: { id } });
      yield put(toggleModal(nameSpace));
    }

    yield put(setLoading(false));
  } catch (err) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}

export function* businessClientSagas() {
  yield takeLatest(
    businessClientActions.fetchGridList,
    fetchBusinessClientsSaga,
  );
  yield takeLatest(
    businessClientActions.fetchGridRowDetails,
    fetchBusinessClientDetailsSaga,
  );
  yield takeLatest(
    businessClientActions.createRowEntry,
    createBusinessClientSaga,
  );
  yield takeLatest(
    businessClientActions.updateRowEntry,
    updateBusinessClientSaga,
  );
}
